<template>
  <div id="app">
    <!-- 路由导航 -->
    <!-- <nav> -->
      <!-- <router-link to="/">首页</router-link> -->
      <!-- <router-link to="/about">关于我们</router-link> -->
    <!-- </nav> -->

    <!-- 路由出口 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}

nav {
  margin-bottom: 20px;
}

nav a {
  margin: 0 10px;
  text-decoration: none;
  color: #42b983;
}

nav a.router-link-exact-active {
  color: #2c3e50;
  font-weight: bold;
}
</style>